<template>
  <div
    class="dataBaseDetailContent"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <div class="section">
      <div
        class="content"
        v-if="item.category == 1 || item.category == 3 || item.category == 4 || item.category == 5 || item.category == 6"
      >
        <div class="title eng_title">{{ item.englishName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts">
              <div class="img_top">
                <div class="picture" v-if="bigImgUrl">
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 153px;
                    "
                    @click.native="bigImg(items)"
                  >
                    <img  :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
            </div>
            <!-- 单张图片不设轮播，减少性能损耗 -->
            <!-- <div v-else class="spec-preview">
              <img :src="url + List[0].fileUrl" alt="" />
              <div class="event" @mousemove="handler"></div>
              <div class="big">
                <img :src="url + List[0].fileUrl" ref="big" />
              </div>
              <div class="mask" ref="mask"></div>
            </div> -->
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author eng_author" v-if="authorDetail.inheritorEnglishName">
                  Author：{{ authorDetail.inheritorEnglishName }}
                </div>
                <!-- <div class="author eng_author" v-else>
                  Author：Not available yet
                </div> -->
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">Representative inheritor of Regong art, a national intangible cultural heritage project</div>
                      <div v-if="items&&items==2">Representative inheritor of Regong art, an intangible cultural heritage project in Qinghai Province</div>
                      <div v-if="items&&items==3">Representative inheritor of Regong art, an intangible cultural heritage project in Huangnan Prefecture, Qinghai Province</div>
                      <div v-if="items&&items==4">Representative inheritor of Regong art, an intangible cultural heritage project in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">Chinese Arts and Crafts Masters</div>
                      <div v-if="items&&items==2">Master of Arts and Crafts in Qinghai Province</div>
                      <div v-if="items&&items==3">Master of Arts and Crafts in Huangnan Prefecture, Qinghai Province</div>
                      <div v-if="items&&items==4">Master of Arts and Crafts in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.englishMaterial&&item.category != 3"
                    >Materials：（{{engLishCateName}}）{{ item.englishMaterial }}</span
                  >
                  <!-- <span class="quality" v-else
                    >Materials：Not available yet</span
                  > -->
                  <span class="size" v-if="item.size"
                    >Size：{{ item.size }}</span
                  >
                  <!-- <span class="size" v-else>Size：Not available yet</span> -->
                </div>
              </div>
              <div class="paintingAcademy">
                <div
                  class="academy eng_academy"
                  v-if="
                    eng_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''
                  "
                >
                  {{ item.templeName }}
                </div>
                <div
                  class="introduce"
                  v-if="
                    eng_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''
                  "
                  v-html="eng_paintingIntroduction"
                ></div>
                <div class="introduce" v-else></div>
              </div>
              <div class="introduction">
                <div
                  class="introductionName eng_introductionName"
                  v-if="item.englishProfile.replace(/<[^<>]+>/g, '') !== ''"
                >
                  Work Introduction
                </div>
                <div
                  v-html="item.englishProfile"
                  v-if="item.englishProfile.replace(/<[^<>]+>/g, '') !== ''"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName eng_perceptionName"
                  v-if="item.englishRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  Work Insights
                </div>
                <div
                  class="introduce"
                  v-html="item.englishRemark"
                  v-if="item.englishRemark.replace(/<[^<>]+>/g, '') !== ''"
                ></div>
                <div class="introduce" v-else></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + eng_voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="item.category == 2">
        <div class="title eng_title">{{ item.englishName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts" v-show="isShow==false">
              <div class="img_top">
                <div class="picture pit" v-if="bigImgUrl">
                  <!-- <div class="picture_img"></div> -->
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 160px;
                    "
                     @click.native="bigImg(items)"
                  >
                    <img :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
              <div class="threeDbutton" @click="show()">
                <div class="button">3D Model</div>
              </div>
            </div>
            <div class="img" v-show="isShow==true">
              <div id="container" element-loading-text="模型加载中"
                element-loading-spinner="el-icon-loading" v-loading="loading" style="width:100%;" ref="container">
              </div>
              <div class="threeDbutton" @click="showPicture()">
                 <div class="button">Picture</div>
              </div>
            </div>
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author eng_author" v-if="authorDetail.inheritorEnglishName">
                  Author：{{ authorDetail.inheritorEnglishName }}
                </div>
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">Representative inheritor of Regong art, a national intangible cultural heritage project</div>
                      <div v-if="items&&items==2">Representative inheritor of Regong art, an intangible cultural heritage project in Qinghai Province</div>
                      <div v-if="items&&items==3">Representative inheritor of Regong art, an intangible cultural heritage project in Huangnan Prefecture, Qinghai Province</div>
                      <div v-if="items&&items==4">Representative inheritor of Regong art, an intangible cultural heritage project in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">Chinese Arts and Crafts Masters</div>
                      <div v-if="items&&items==2">Master of Arts and Crafts in Qinghai Province</div>
                      <div v-if="items&&items==3">Master of Arts and Crafts in Huangnan Prefecture, Qinghai Province</div>
                      <div v-if="items&&items==4">Master of Arts and Crafts in Tongren City, Huangnan Prefecture, Qinghai Province</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.englishMaterial&&item.category != 2"
                    >Materials：（{{engLishCateName}}）{{ item.englishMaterial }}</span
                  >
                  <span class="size" v-if="item.size"
                    >Size：{{ item.size }}</span
                  >
                </div>
              </div>
              <div class="paintingAcademy">
                <div
                  class="academy eng_academy"
                  v-if="
                    eng_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''
                  "
                >
                  {{ item.templeName }}
                </div>
                <div
                  class="introduce"
                  v-if="
                    eng_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''
                  "
                  v-html="eng_paintingIntroduction"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="introduction">
                <div
                  class="introductionName eng_introductionName"
                  v-if="item.englishProfile.replace(/<[^<>]+>/g, '') !== ''"
                >
                  Work Introduction
                </div>
                <div
                  v-if="item.englishProfile.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="item.englishProfile"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName eng_perceptionName"
                  v-if="item.englishRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  Work Insights
                </div>
                <div
                  v-if="item.englishRemark.replace(/<[^<>]+>/g, '') !== ''"
                  class="introduce"
                  v-html="item.englishRemark"
                ></div>
                <div v-else class="introduce"></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + eng_voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dataBaseDetailContent" v-else-if="this.language == 'en'">
    <div class="section">
      <div
        class="content"
        v-if="item.category == 1 || item.category == 3 || item.category == 4 || item.category == 5 || item.category == 6"
      >
        <div class="title">{{ item.zangName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts">
              <div class="img_top">
                <div class="picture" v-if="bigImgUrl">
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 153px;
                    "
                     @click.native="bigImg(items)"
                  >
                    <img :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
            </div>
            <!-- 单张图片不设轮播，减少性能损耗 -->
            <!-- <div v-else class="spec-preview">
              <img :src="url + List[0].fileUrl" alt="" />
              <div class="event" @mousemove="handler"></div>
              <div class="big">
                <img :src="url + List[0].fileUrl" ref="big" />
              </div>
              <div class="mask" ref="mask"></div>
            </div> -->
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author" v-if="authorDetail.inheritorZangName">
                  རྩོམ་པ་པོ།{{ authorDetail.inheritorZangName }}
                </div>
                <!-- <div class="author" v-else>རྩོམ་པ་པོ།：གནས་སྐབས་སུ་མེད།</div> -->
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==4">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་</div>
                      <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་</div>
                      <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                      <div v-if="items&&items==4">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.zangMaterial&&item.category != 3">
                    རྒྱུ་ཆའི་སྤུས་ཚད།（{{zangCateName}}）{{ item.zangMaterial }}</span
                  >
                  <!-- <span class="quality" v-else>
                    རྒྱུ་ཆའི་སྤུས་ཚད།：གནས་སྐབས་སུ་མེད།</span
                  > -->
                  <span class="size" v-if="item.size"
                    >ཆེ་ཆུང་།{{ item.size }}</span
                  >
                  <!-- <span class="size" v-else>ཆེ་ཆུང་།：གནས་སྐབས་སུ་མེད།</span> -->
                </div>
              </div>
              <div class="paintingAcademy">
                <div
                  class="academy"
                  v-if="za_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                >
                  {{ item.templeName }}
                </div>
                <div
                  class="introduce"
                  v-if="za_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="za_paintingIntroduction"
                ></div>
                <div class="introduce" v-else></div>
              </div>
              <div class="introduction">
                <div
                  class="introductionName"
                  v-if="item.zangProfile.replace(/<[^<>]+>/g, '') !== ''"
                >
                  བརྩམས་ཆོས་མཚམས་སྦྱོར།
                </div>
                <div
                  v-if="item.zangProfile.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="item.zangProfile"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName"
                  v-if="item.zangRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  བརྩམས་ཆོས་ཀྱི་མྱོང་ཚོར།
                </div>
                <div
                  class="introduce"
                  v-html="item.zangRemark"
                  v-if="item.zangRemark.replace(/<[^<>]+>/g, '') !== ''"
                ></div>
                <div class="introduce" v-else></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + za_voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="item.category == 2">
        <div class="title">{{ item.zangName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts" v-show="isShow==false">
              <div class="img_top">
                <div class="picture pit" v-if="bigImgUrl">
                  <!-- <div class="picture_img"></div> -->
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 160px;
                    "
                     @click.native="bigImg(items)"
                  >
                    <img :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
              <div class="threeDbutton" @click="show()">
                <div class="button">3Dདབྱིབས་གཟུགས།</div>
              </div>
            </div>
            <div class="img" v-show="isShow==true">
              <div id="container" element-loading-text="模型加载中"
                element-loading-spinner="el-icon-loading" v-loading="loading" style="width:100%;" ref="container">
              </div>
              <div class="threeDbutton" @click="showPicture()">
                 <div class="button">པར་རིས།</div>
              </div>
            </div>
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author" v-if="authorDetail.inheritorZangName">
                  རྩོམ་པ་པོ།{{ authorDetail.inheritorZangName }}
                </div>
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                      <div v-if="items&&items==4">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་</div>
                      <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་</div>
                      <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                      <div v-if="items&&items==4">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.zangMaterial&&item.category!=2"
                    >རྒྱུ་ཆའི་སྤུས་ཚད།（{{zangCateName}}）{{ item.zangMaterial }}</span
                  >
                  <span class="size" v-if="item.size"
                    >ཆེ་ཆུང་།{{ item.size }}</span
                  >
                </div>
              </div>
              <div class="paintingAcademy">
                <div
                  class="academy"
                  v-if="za_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                >
                  {{ item.templeName }}
                </div>
                <div
                  v-if="za_paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="za_paintingIntroduction"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="introduction">
                <div
                  class="introductionName"
                  v-if="item.zangProfile.replace(/<[^<>]+>/g, '') !== ''"
                >
                  བརྩམས་ཆོས་མཚམས་སྦྱོར།
                </div>
                <div
                  v-html="item.zangProfile"
                  v-if="item.zangProfile.replace(/<[^<>]+>/g, '') !== ''"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName"
                  v-if="item.zangRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  བརྩམས་ཆོས་ཀྱི་མྱོང་ཚོར།
                </div>
                <div
                  v-html="item.zangRemark"
                  v-if="item.zangRemark.replace(/<[^<>]+>/g, '') !== ''"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + za_voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dataBaseDetailContent" v-else>
    <div class="section">
      <div
        class="content"
        v-if="item.category == 1 || item.category == 3 || item.category == 4 || item.category == 5 || item.category == 6"
      >
        <div class="title">{{ item.chineseName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts">
              <div class="img_top">
                <div class="picture pit" v-if="bigImgUrl">
                  <!-- <div class="picture_img"></div> -->
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 160px;
                    "
                     @click.native="bigImg(items)"
                  >
                    <img :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
            </div>
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author" v-if="authorDetail.inheritorChineseName">
                  作者：{{ authorDetail.inheritorChineseName }}
                </div>
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">国家级非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==2">青海省非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==3">青海省黄南州非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==4">青海省黄南州同仁市非遗项目热贡艺术代表性传承人</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">中国工艺美术大师</div>
                      <div v-if="items&&items==2">青海省工艺美术大师</div>
                      <div v-if="items&&items==3">青海省黄南州工艺美术大师</div>
                      <div v-if="items&&items==4">青海省黄南州同仁市工艺美术大师</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.chineseMaterial&&item.category != 3"
                    >材质：（{{item.categoryName}}）{{ item.chineseMaterial }}</span
                  >
                  <!-- <span class="quality" v-else>材质：暂无</span> -->
                  <span class="size" v-if="item.size"
                    >尺寸：{{ item.size }}</span
                  >
                  <!-- <span class="size" v-else>尺寸：暂无</span> -->
                </div>
              </div>
              <div class="paintingAcademy">
                <div class="academy">{{ item.templeName }}</div>
                <div
                  v-html="paintingIntroduction"
                  class="introduce"
                  v-if="paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                ></div>
                <div class="introduce" v-else></div>
              </div>
              <div class="introduction">
                <div
                  class="introductionName"
                  v-if="item.chineseProfile.replace(/<[^<>]+>/g, '') !== ''"
                >
                  作品简介
                </div>
                <div
                  v-if="item.chineseProfile.replace(/<[^<>]+>/g, '') !== ''"
                  class="introduce"
                  v-html="item.chineseProfile"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName"
                  v-if="item.chineseRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  作品感悟
                </div>
                <div
                  class="introduce"
                  v-if="item.chineseRemark.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="item.chineseRemark"
                ></div>
                <div class="introduce" v-else></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="item.category == 2">
        <div class="title">{{ item.chineseName }}</div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <div class="lefts" v-show="isShow==false">
              <div class="img_top">
                <div class="picture pit" v-if="bigImgUrl">
                  <!-- <div class="picture_img"></div> -->
                  <img :src="url + bigImgUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big">
                    <img
                      class="bigImg hidden-xs-only"
                      :src="url + bigImgUrl"
                      alt=""
                      ref="big"
                    />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
                <div class="picture" v-else>
                  <img :src="url + item.picture.fileUrl" alt="" />
                  <!-- 定义鼠标事件 -->
                  <div class="pre_event hidden-xs-only" @mousemove="handler"></div>
                  <!-- 定义放大后的图样式 -->
                  <div class="pre_big hidden-xs-only">
                    <img :src="url + item.picture.fileUrl" ref="big" />
                  </div>
                  <!-- 遮罩层 -->
                  <div class="pre_mask hidden-xs-only" ref="mask"></div>
                </div>
              </div>
              <div class="img_bottom" v-if="item.bannerPicture.length > 0">
                <swiper
                  v-if="item.bannerPicture.length > 0"
                  :options="swiperOption"
                  ref="mySwiper"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(items, index) in item.bannerPicture"
                    :key="index"
                    style="
                      position: relative;
                      overflow: hidden;
                      width: 600px;
                      height: 160px;
                    "
                     @click.native="bigImg(items)"
                  >
                    <img :src="url + items.fileUrl" />
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>
                  <!-- 左右箭头 -->
                  <div class="swiper-button-prev" slot="button-prev">
                    <div>
                      <i class="el-icon-arrow-left"></i>
                    </div>
                  </div>
                  <div class="swiper-button-next" slot="button-next">
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </swiper>
              </div>
              <div class="threeDbutton" @click="show()">
                <div class="button">3D模型</div>
              </div>
            </div>
            <div class="img" v-show="isShow==true">
              <div id="container" element-loading-text="模型加载中"
                element-loading-spinner="el-icon-loading" v-loading="loading" ref="container" style="width:100%;">
              </div>
              <div class="threeDbutton" @click="showPicture()">
                 <div class="button">图片</div>
              </div>
            </div>
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_top">
              <div class="authorAbout">
                <div class="author" v-if="authorDetail.inheritorChineseName">
                  作者：{{ authorDetail.inheritorChineseName }}
                </div>
                <div class="authorJob">
                  <div class="inheritorNameList" v-if="authorDetail.inheritorLevelIdArrStr&&authorDetail.inheritorLevelIdArrStr.length>0">
                    <div>非遗传承人：</div>
                    <div class="inheritorNameItem" v-for="(items,index) in authorDetail.inheritorLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">国家级非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==2">青海省非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==3">青海省黄南州非遗项目热贡艺术代表性传承人</div>
                      <div v-if="items&&items==4">青海省黄南州同仁市非遗项目热贡艺术代表性传承人</div>
                    </div>
                  </div>
                  <div class="artistsLevelNameList" v-if="authorDetail.artistsLevelIdArrStr&&authorDetail.artistsLevelIdArrStr.length>0">
                    <div>工艺美术师：</div>
                    <div class="artistsLevelNameItem" v-for="(items,index) in authorDetail.artistsLevelIdArrStr" :key="index">
                      <div v-if="items&&items==1">中国工艺美术大师</div>
                      <div v-if="items&&items==2">青海省工艺美术大师</div>
                      <div v-if="items&&items==3">青海省黄南州工艺美术大师</div>
                      <div v-if="items&&items==4">青海省黄南州同仁市工艺美术大师</div>
                    </div>
                  </div>
                </div>
                <div class="author_top">
                  <span class="quality" v-if="item.chineseMaterial"
                    >材质：（{{item.categoryName}}）{{ item.chineseMaterial }}</span
                  >
                  <span class="size" v-if="item.size"
                    >尺寸：{{ item.size }}</span
                  >
                </div>
              </div>
              <div class="paintingAcademy">
                <div
                  class="academy"
                  v-if="paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                >
                  {{ item.templeName }}
                </div>
                <div
                  v-html="paintingIntroduction"
                  class="introduce"
                  v-if="paintingIntroduction.replace(/<[^<>]+>/g, '') !== ''"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="introduction">
                <div
                  v-if="item.chineseProfile.replace(/<[^<>]+>/g, '') !== ''"
                  class="introductionName"
                >
                  作品简介
                </div>
                <div
                  v-if="item.chineseProfile"
                  class="introduce"
                  v-html="item.chineseProfile"
                ></div>
                <div v-else class="introduce"></div>
              </div>
              <div class="perception">
                <div
                  class="perceptionName"
                  v-if="item.chineseRemark.replace(/<[^<>]+>/g, '') !== ''"
                >
                  作品感悟
                </div>
                <div
                  v-if="item.chineseRemark.replace(/<[^<>]+>/g, '') !== ''"
                  v-html="item.chineseRemark"
                  class="introduce"
                ></div>
                <div v-else class="introduce"></div>
              </div>
            </div>
            <div class="audio">
              <div class="audioImg" @click="showAudios" v-if="showAudio">
                <img src="../assets/dataType/play.png" alt="" />
              </div>
              <div class="audioItem" v-if="!showAudio">
                <audio
                  ref="audio"
                  @pause="onPause"
                  @play="onPlay"
                  @ended="onEnd"
                  @timeupdate="onTimeupdate"
                  @loadedmetadata="onLoadedmetadata"
                  :src="url + voiceUrl"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
function realFormatSecond(second) {
  var secondType = typeof second;
  if (secondType === "number" || secondType === "string") {
    second = parseInt(second);
    var hours = Math.floor(second / 3600);
    second = second - hours * 3600;
    var mimute = Math.floor(second / 60);
    second = second - mimute * 60;
    return (
      hours + ":" + ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2)
    );
  } else {
    return "0:00:00";
  }
}
import { productGet, templeGet } from "../api/management.js";
import * as THREE from "three";
import { OBJLoader, MTLLoader } from 'three-obj-mtl-loader';
import OrbitControls from 'three-orbitcontrols'
var scene,
  controls,
  camera,
  renderer,
  mtlLoader,
  objLoader,
  textureLoader,
  directionalLight_a,
  directionalLight_b,
  directionalLight_c,
  directionalLight_d,
  ambient;
export default {
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      title: "",
      id: this.$route.query.id,
      item: {},
      eng_paintingIntroduction: "",
      paintingIntroduction: "",
      za_paintingIntroduction: "",
      category: "", //分类ID
      templeId: "", //画院ID
      //3d模型
      width: "500",
      height: "500",
      pngFileURL: "",
      mtlFileURL: "",
      objFileURL: "",
      isShow: false,
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
      voiceUrl: "",
      za_voiceUrl: "",
      eng_voiceUrl: "",
      showAudio: true,
      swiperOption: {
        loop: false, //是否循环轮播
        slidesPerView: 3,
        spaceBetween: 10, //间距
        //左右切换
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      bigImgUrl: "",
      List: [],
      loading:true,
      engLishCateName:'',
      zangCateName:'',

      // 作者相关
      authorDetail:{
        inheritorChineseName: '',//中文
        inheritorZangName:'',//藏文
        inheritorEnglishName:'',//英文
        inheritorLevelIdArrStr: [],
        artistsLevelIdArrStr: [],
      },
    }
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getProductGet();
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? "暂停" : "播放";
    },
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second);
    },
  },
  methods: {
    //(最佳放大镜效果，可以自动根据后端传回来的图片尺寸来控制图片放大的效果)
    handler(event) {
      let mask = this.$refs.mask;
      let big = this.$refs.big;
      //left和top与css中放大效果是1比1控制
      let left = event.offsetX - mask.offsetWidth / 2;
      let top = event.offsetY - mask.offsetHeight / 2;
      //约束范围
      if (left <= 0) left = 0;
      if (left >= mask.offsetWidth) left = mask.offsetWidth;
      if (top <= 0) top = 0;
      if (top >= mask.offsetHeight) top = mask.offsetHeight;
      mask.style.left = left + "px";
      mask.style.top = top + "px";
      big.style.left = -2 * left + "px";
      big.style.top = -2 * top + "px";
    },
    async getProductGet() {
      const res = await productGet(this.id);
      this.item = res.data;
      this.bigImgUrl = res.data.watermark[0].fileUrl
      if (res.data.bannerPicture.length > 0) {
        this.List = res.data.bannerPicture;
        this.List.push(res.data.watermark[0])
      }
      this.category = res.data.category;
      if(res.data.category==1) {
        this.engLishCateName = 'Thangka'
        this.zangCateName = 'ཐང་ག'
      } else if(res.data.category==2) {
        this.engLishCateName = 'Clay sculpture'
        this.zangCateName = 'འཇིམ་བཟོ།'
      } else if(res.data.category==3) {
        this.engLishCateName = 'Mural'
        this.zangCateName = 'ལྡེབས་རིས།'
      } else if(res.data.category==4) {
        this.engLishCateName = 'Pile embroidery'
        this.zangCateName = 'དྲས་དྲུབ།'
      } else if(res.data.category==5) {
        this.engLishCateName = ' Paintings'
        this.zangCateName = 'ཚོན་རིས།'
      }
      if (res.data.chineseAudio) {
        this.voiceUrl = res.data.chineseAudio.fileUrl;
      }
      if (res.data.englishAudio) {
        this.eng_voiceUrl = res.data.englishAudio.fileUrl;
      }
      if (res.data.zangAudio) {
        this.za_voiceUrl = res.data.zangAudio.fileUrl;
      }
      let templeId = res.data.templeId;
      this.templeId = res.data.templeId;
      if (res.code == 1) {
        if(res.data.otherInheritorChineseName) {
          this.authorDetail.inheritorChineseName = res.data.otherInheritorChineseName;
          this.authorDetail.inheritorZangName = res.data.otherInheritorZangName;
          this.authorDetail.inheritorEnglishName = res.data.otherInheritorEnglishName;
          this.authorDetail.inheritorLevelIdArrStr = res.data.otherInheritorLevelIdArrStr;
          this.authorDetail.artistsLevelIdArrStr = res.data.otherArtistsLevelIdArrStr;
        }
        if(res.data.inheritorChineseName) {
          this.authorDetail.inheritorChineseName = res.data.inheritorChineseName;
          this.authorDetail.inheritorZangName = res.data.inheritorZangName;
          this.authorDetail.inheritorEnglishName = res.data.inheritorEnglishName;
          this.authorDetail.inheritorLevelIdArrStr = res.data.inheritorLevelIdArrStr;
          this.authorDetail.artistsLevelIdArrStr = res.data.artistsLevelIdArrStr;
        }
        this.getTempleGet(templeId)
        if(res.data.category==2) {
          let modelList = res.data.file3d;
          let modelUrlList = [];
          modelList.forEach((item) => {
            modelUrlList.push(item.fileUrl);
          });
          modelUrlList.forEach((item) => {
            if (item.indexOf("png" || "jpg") !== -1) {
              this.pngFileURL = this.url + item;
            } else if (item.indexOf("mtl") !== -1) {
              this.mtlFileURL = this.url + item;
            } else if (item.indexOf("obj") !== -1) {
              this.objFileURL = this.url + item;
            }
          });
          this.$nextTick(() => {
            this.handleInit();
            this.animate();
          });
        }
      console.log(this.item);
      }
    },
    async getTempleGet(templeId) {
      const res = await templeGet(templeId);
      this.paintingIntroduction = res.data.chineseSummary;
      this.eng_paintingIntroduction = res.data.englishSummary;
      this.za_paintingIntroduction = res.data.zangSummary;
    },
    // 3D
    // 显示3d
    show() {
      this.isShow = true;
      // this.$nextTick(() => {
      //   this.handleInit();
      //   this.animate();
      // });
    },
    showPicture() {
      // let elem = document.querySelector('canvas');
      // elem.parentNode.removeChild(elem);
      this.isShow = false;
      // this.loading = true;
    },
    // 初始化模型
    handleInit() {
      // 创建场景
      scene = new THREE.Scene();
      mtlLoader = new THREE.MTLLoader();
      objLoader = new THREE.OBJLoader();
      textureLoader = new THREE.TextureLoader();
      mtlLoader.setCrossOrigin("Anonymous");
      mtlLoader.load(this.mtlFileURL, (materials) => {
        materials.preload();
        objLoader.setMaterials(materials);
      });
      objLoader.load(this.objFileURL, (object) => {
        scene.add(object);
        object.position.set(0, -60, 0);
        textureLoader.load(this.pngFileURL, (texture) => {
          object.children.forEach((item) => {
            item.material = new THREE.MeshBasicMaterial({
              map: texture,
              side: THREE.DoubleSide,
            });
          });
        });
        this.onAfterRender(object, 0, 0, () => {
            this.loading = false
        })
      });
      // 添加光源
      directionalLight_a = new THREE.DirectionalLight(0x999999, 1);
      directionalLight_a.position.set(200, 200, 200);
      scene.add(directionalLight_a);
      directionalLight_b = new THREE.DirectionalLight(0x999999, 1);
      directionalLight_b.position.set(-200, -200, -200);
      scene.add(directionalLight_b);
      directionalLight_c = new THREE.DirectionalLight(0x999999, 1);
      directionalLight_c.position.set(-200, 200, 200);
      scene.add(directionalLight_c);
      directionalLight_d = new THREE.DirectionalLight(0x999999, 1);
      directionalLight_d.position.set(200, -200, -200);
      scene.add(directionalLight_d);
      ambient = new THREE.AmbientLight(0x999999);
      scene.add(ambient);
      // 设置相机
      camera = new THREE.PerspectiveCamera(
        45,
        this.width / this.height,
        1,
        1000
      );
      camera.position.set(200, 0, 300);
      camera.lookAt(scene.position);
      // 渲染
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        precision: "lowp",
      });
      renderer.setSize(this.width, this.height);
      renderer.setClearColor(0xeeeeee, 1);
      renderer.shadowMapEnabled = true;
      if (this.$refs.container) {
        this.$nextTick(() => {
          this.$refs.container.appendChild(renderer.domElement);
        });
      }
      // 鼠标事件
      controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls.addEventListener("change", this.render);
      controls.enableDamping = true;
      controls.enableZoom = true;
      controls.enablePan = true;
    },
    getImageCount (model) {
        let iCount = 0
        model.traverse(item => {
            if (item instanceof THREE.Mesh) {
            if (Array.isArray(item.material)) {
                item.material.forEach(m => {
                if (m.map && m.map.image) {
                    iCount++
                }
                })
            } else {
                if (item.material.map && item.material.map.image) {
                iCount++
                }
            }
            }
        })
        return iCount
    },
    onAfterRender (model, ic, ec, callback) {
        const wait = 3
        let iCount = ic
        let equalCount = ec
        setTimeout(() => {
            const res = this.getImageCount(model)
            if (iCount === res) {
            if (equalCount === wait) {
                callback()
            } else {
                equalCount++
                this.onAfterRender(model, iCount, equalCount, callback)
            }
            } else {
                iCount = res
                equalCount = 0
                this.onAfterRender(model, iCount, equalCount, callback)
            }
        }, 100)
    },
    render() {
      renderer.render(scene, camera);
    },
    animate() {
      this.render();
      scene.rotateY(0.005);
      requestAnimationFrame(this.animate);
    },
    // 判断手机端还是PC端
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.width = 320;
        this.height = 380;
      } else {
        this.width = 430;
        this.height = 500;
      }
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play();
    },
    // 播放音频
    play() {
      this.$refs.audio.play();
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause();
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true;
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false;
    },
    onEnd() {
      this.showAudio = true;
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.audio.currentTime = res.target.currentTime;
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audio.maxTime = parseInt(res.target.duration);
    },
    showAudios() {
      this.showAudio = false;
    },
    bigImg(item) {
      this.bigImgUrl = item.fileUrl;
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  beforeDestroy() {
    scene = null;
    controls = null;
    camera = null;
    renderer = null;
    mtlLoader = null;
    objLoader = null;
    textureLoader = null;
    directionalLight_a = null;
    directionalLight_b = null;
    ambient = null;
  },
};
</script>
<style lang='scss' scoped>
.dataBaseDetailContent {
  position: relative;
  margin-bottom: 50px;
  .section {
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        padding: 50px 0;
        text-align: center;
        font-size: 36px;
        font-family: "fangzang";
      }
      .eng_title {
        font-family: "Times New Roman", Times, serif;
      }
      .middle {
        display: flex;
        .left {
          //宽度不能设死，会影响单张图片和轮播多张图片的设计展示
          min-height: 450px;
          width: 600px;
          z-index: 998;
          .lefts {
            width: 100%;
            display: flex;
            // height: 500px;
            flex-direction: column;
            .img_top {
              .picture {
                position: relative;
                border: 1px solid #ccc;
                background-color: #f5f5f9;
                height: 450px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit:contain;
                }
                .pre_event {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 998;
                }
                .pre_mask {
                  width: 50%;
                  height: 50%;
                  background-color: rgba(255, 255, 255, 0.5);
                  position: absolute;
                  left: 0;
                  top: 0;
                  display: none;
                }
                .pre_big {
                  width: 100%;
                  height: 450px;
                  position: absolute;
                  top: -1px;
                  //left至少要101%，不可紧贴，只要图片之间有缝隙即可，否则展示图片会产生错误
                  left: 101%;
                  border: 1px solid #aaa;
                  overflow: hidden;
                  z-index: 998;
                  display: none;
                  background: white;
                  img {
                    height: 200%;
                    position: absolute;
                    width: 200%;
                    left: -100%;
                    top: 0;
                  }
                }
                .pre_event:hover ~ .pre_mask,
                .pre_event:hover ~ .pre_big {
                  display: block;
                }
              }
              .bigImg {
                position: absolute;
                top: 0;
                left: 0;
              }
            }
            .img_bottom {
              margin-top: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              .swiper-container {
                width: 100%;
                .swiper-wrapper {
                  height: 160px !important;
                  .swiper-slide {
                    position: relative;
                    height: 160px !important;
                    img {
                      height: 100%;
                      width: 100%;
                    }
                  }
                }
                .swiper-button-prev,
                .swiper-button-next {
                  position: absolute;
                  background: none;
                  background-color: #b89557;
                  width: 19px;
                  height: 32px;
                  opacity: 1;
                }
                .swiper-button-prev {
                  left: 0;
                  top: 50%;
                }
                .swiper-button-next {
                  right: 0;
                  top:50%;
                }
                .swiper-button-prev::after {
                  content: "";
                }
                .swiper-button-next::after {
                  content: "";
                }
              }
              .noPicture {
                font-size: 20px;
              }
            }
            .threeDbutton{
              display: flex;
              margin-top: 10px;
              .button{
                color: #fff;
                padding: 10px 20px;
                background-color: #981118;
                cursor: pointer;
                border-radius: 10px;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .spec-preview {
            position: relative;
            height: 500px;
            border: 1px solid #ccc;
            img {
              height: 100%;
            }
            //控制遮罩层移动的位置
            .event {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 998;
            }
            .mask {
              width: 50%;
              height: 50%;
              background-color: rgba(255, 255, 255, 0.5);
              position: absolute;
              left: 0;
              top: 0;
              display: none;
            }
            .big {
              width: 100%;
              height: 500px;
              position: absolute;
              top: -1px;
              //left至少要101%，不可紧贴，只要图片之间有缝隙即可，否则展示图片会产生错误
              left: 120%;
              border: 1px solid #aaa;
              overflow: hidden;
              z-index: 998;
              display: none;
              background: white;
              img {
                height: 200%;
                position: absolute;
                left: 0;
                top: 0;
              }
            }
            .event:hover ~ .mask,
            .event:hover ~ .big {
              display: block;
            }
          }
          .img {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 600px;
            img {
              height: 100%;
              width: 100%;
              object-fit:contain;
            }
            .threeDbutton{
              display: flex;
              margin-top: 10px;
              .button{
                color: #fff;
                padding: 10px 20px;
                background-color: #981118;
                cursor: pointer;
                border-radius: 10px;
              }
            }
            #container {
              width: 450px;
              height: 100%;
              display: flex;
              justify-content: center;
            }
            /deep/.el-loading-mask {
              .el-loading-spinner {
                .el-icon-loading {
                  color: #ef3731!important;
                }
                .el-loading-text {
                  color: #ef3731!important;
                }
              }
            }
          }
        }
        .right {
          width: 600px;
          padding: 45px;
          display: flex;
          align-items: center;
          background-color: #f5f5f5;
          z-index: 2;
          .right_top {
            span {
              font-size: 15px;
            }
            p {
              font-size: 15px;
              line-height: 24px;
            }
            .authorJob {
              margin-top: 6px;
              font-size: 15px;
              .inheritorNameList {
                margin-bottom: 6px;
                display: flex;
              }
              .artistsLevelNameList{
                display: flex;
              }
            }
            .authorAbout {
              .author {
                font-size: 24px;
                font-family: "fangzang";
              }
              .eng_author {
                font-family: "Times New Roman", Times, serif;
              }
              .author_top {
                margin-top: 20px;
                .size {
                  display: inline-block;
                }
                .quality {
                  margin-right: 40px;
                }
              }
            }
            .paintingAcademy,
            .introduction,
            .perception {
              margin-top: 34px;
              .academy,
              .introductionName,
              .perceptionName {
                font-size: 24px;
                font-family: "fangzang";
                margin-bottom: 6px;
              }
              .eng_academy,
              .eng_introductionName,
              .eng_perceptionName {
                font-family: "Times New Roman", Times, serif;
              }
            }
            .introduce {
              text-align: justify;
              font-size: 16px;
              line-height: 1.5;
            }
          }
          .audio {
            position: absolute;
            top: 3%;
            right: 3%;
            .audioImg {
              background-color: #971118;
              width: 30px;
              height: 30px;
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .cloud {
    position: absolute;
    right: 0%;
    bottom: 0%;
  }
}
@media (max-width: 768px) {
  .dataBaseDetailContent {
    margin-bottom: 0;
    .section {
      .content {
        .title {
          font-size: 0.4rem;
          padding: 0.5rem 0;
        }
        .middle {
          width: 100%;
          display: flex;
          flex-direction: column;
          .left {
            min-height: 8rem;
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 0.5rem;
            .lefts {
              .img_top {
                width: 100%;
                .picture {
                  height: 8rem!important;
                }
              }
            .img_bottom {
              height: 2.25rem;
              width: 100%;
              margin-top: .2rem!important;
              .swiper-container {
                width: 100%;
                .swiper-wrapper {
                  width: 100% !important;
                  height: 2.25rem !important;
                  .swiper-slide {
                    width: 2.23rem !important;
                    height: 2.255rem !important;
                    margin-right: 0.15rem;
                    .img {
                      height: 2.25rem !important;
                    }
                  }
                }
                .swiper-button-prev::after {
                  content: "";
                }
                .swiper-button-prev {
                  position: absolute;
                  background: none;
                  background-color: #b89557;
                  height: 0.5rem;
                  width: 0.3rem;
                  left: 0;
                  top: 1rem;
                }
                .swiper-button-next::after {
                  content: "";
                }
                .swiper-button-next {
                  position: absolute;
                  background: none;
                  background-color: #b89557;
                  height: 0.5rem;
                  width: 0.3rem;
                  right: 0.05rem;
                  top: 1rem;
                }
                .swiper-button-prev {
                  top: 1.35rem;
                }
                .swiper-button-next {
                  top: 1.35rem;
                }
              }
            }
            .threeDbutton{
              display: flex;
              margin-top: .2rem;
            }
            }
            .img {
              width: 100% !important;
              height: 450px;
              img {
                 width: 100% !important;
              }
              #container {
                height: 100%;
                display: flex;
                justify-content: center;
              }
            }
          }
          .right {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: .5rem 0.08rem 0.3rem 0.08rem;
            margin-top: .3rem;
            .right_top {
              .authorAbout {
                .author {
                  text-align: center;
                  font-size: 0.4rem;
                }
                .author_top {
                  text-align: center;
                  .quality {
                    margin-right: 0.2rem;
                  }
                }
              }
              .paintingAcademy {
                margin-top: 0.3rem;
                .academy {
                  text-align: center;
                  font-size: 0.4rem;
                }
                p {
                  text-indent: 2em;
                }
              }
              .introduction {
                margin: 0.3rem 0;
                .introductionName {
                  text-align: center;
                  font-size: 0.4rem;
                }
                p {
                  text-indent: 2em;
                }
              }
              .perception {
                margin: 0;
                .perceptionName {
                  text-align: center;
                  font-size: 0.4rem;
                }
                p {
                  text-indent: 2em;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
